import React from 'react';
import { Badge } from 'reactstrap';
import i18n from '@/utils/i18n';

const getTrackableItemStatusColor = (archived: boolean): string => {
  if (archived) {
    return 'danger';
  }

  return 'success';
};

type TrackableItemStatusBadgeProps = {
  archived: boolean;
};

const TrackableItemStatusBadge = ({
  archived,
}: TrackableItemStatusBadgeProps) => {
  return (
    <Badge
      color={getTrackableItemStatusColor(archived)}
      className="border border-1"
      pill
    >
      {i18n.t(`TrackableItems:archived_status_${archived}`)}
    </Badge>
  );
};

export default TrackableItemStatusBadge;
